import { render, staticRenderFns } from "./TemplateTwo.vue?vue&type=template&id=a2671f8e&"
import script from "./TemplateTwo.vue?vue&type=script&lang=js&"
export * from "./TemplateTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports